$(function() {
    function formatList(parts) {
        if (parts.length === 1) {
            return parts[0];
        }
        if (parts.length === 2) {
            return parts[0] + ' and ' + parts[1];
        }
        return parts.slice(0, -1).join(', ') + ' and ' + parts[parts.length - 1];
    }
    function showErrorMsg() {
        if ($('#basketItemDealsCount').length) {
            const basketItemDealsCount = JSON.parse($('#basketItemDealsCount').val());
            if (basketItemDealsCount['HandsetSIMOMix']) {
                if ((basketItemDealsCount['PhoneContractLimit'].added > 0 && basketItemDealsCount['SimOnlyContractLimit'].added > 0) || (basketItemDealsCount['PhoneContractLimit'].added > 0 && basketItemDealsCount['UpgradesLimit'].added > 0) || (basketItemDealsCount['SimOnlyContractLimit'].added > 0 && basketItemDealsCount['UpgradesLimit'].added > 0) || (basketItemDealsCount['UpgradesLimit'].added > 0 && basketItemDealsCount['UpgradesSimLimit'].added > 0)) {
                    $('#validation-message-content').text('You can only purchase either a phone or SIM contract at a time.');
                    $('#validation-message-extra').text(' To continue, please remove additional plans you no longer wish to purchase.');
                    $('#message-id').show();
                    return true;
                }
            }
            const labels = {
                PhoneContractLimit: 'phone contract',
                SimOnlyContractLimit: 'SIM Only contract',
                SimFreeLimit: 'SIM-free phone',
                PayGContractLimit: 'pay as you go SIM',
                UpgradesLimit: 'upgrade'
            };
            let allowedParts = [];
            for (const key in basketItemDealsCount) {
                if (key != 'HandsetSIMOMix') {
                    const item = basketItemDealsCount[key];
                    if (item.added > item.allowed) {
                        allowedParts.push(`${item.allowed} ${labels[key]}${item.allowed > 1 ? 's' : ''}`);
                    }
                }
            }
            if (allowedParts.length) {
                $('#validation-message-content').text(`You can only purchase up to ${formatList(allowedParts)} at a time.`);
                $('#validation-message-extra').text(' To continue, please remove additional plans you no longer wish to purchase.');
                $('#message-id').show();
                return true;
            }
        }
        return false;
    }
    showErrorMsg();
    $('body').on('click', '#basketupsellModalBtn', function() {
        if (showErrorMsg()) {
            return false;
        }
        if (window.isUpsellEnabled) {
            const phoneContracts = $('.basket-item[data-type="phone-contract"]').length;
            const upgrades = $('.basket-item[data-type="upgrade"]').length;
            const simonly = $('.basket-item[data-type="sim-only"]').length;
            if ((phoneContracts + upgrades + simonly) > 1) {
                // scroll to top
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
                const msgHtml = `
                    <div class="msg-box msg-box-warning">
                        <span class="msg-box-icon"></span>
                        <p>
                            Sorry, you've ordered too many products. Please just choose one.
                            You can only buy one pay monthly product at a time.
                            To remove a product, click the link below the product image.
                        </p>
                    </div>
                `;
                $('.global-msg-boxes').html(msgHtml);
                $('.sidebar').removeClass('affix');
                // Sidebar - Fixed on Scroll
                const x = window.matchMedia('(min-width: 768px)');
                const sidebarScroll = (x) => {
                    let $sidebar = $('.sidebar');
                    if (x.matches && $sidebar.length) {
                        let stickySidebar = $sidebar.offset().top;
                        $(window).scroll(function() {
                            if ($(window).scrollTop() + 145 > stickySidebar) {
                                $sidebar.addClass('affix');
                            } else {
                                $sidebar.removeClass('affix');
                            }
                        });
                    }
                };
                sidebarScroll(x);
                x.addListener(sidebarScroll);
                // $('#basket-form').submit();
            } else {
                $('.global-msg-boxes').html('');
                $('#basketupsellModal').modal('show');
            }
            var currenDealType = $('#currenDealType').val();
            var dealTagsEncodedClicked = $('#currenDealType').attr('data-dealTagsClicked');
            const dealTagsArrayClicked = JSON.parse(dealTagsEncodedClicked);
            var tagTextsStringClicked = '';
            if (dealTagsArrayClicked.length > 0) {
                tagTextsStringClicked = ', ' + dealTagsArrayClicked.join(', ');
            }
            let upsellMonthlyCost = $(this).attr('data-upsellMonthlyCost');
            let upsellData = $(this).attr('data-upsellData');
            let upsellContrctLength = $(this).attr('data-upsellContrctLength');
            let upsellUpfrontCost = $(this).attr('data-upsellUpfrontCost');
            const dealTagsEncoded = $(this).attr('data-dealTags');
            const dealTags = JSON.parse(dealTagsEncoded);
            let tagTexts = [];
            let dealTagsArray = Object.values(dealTags);
            for (let i = 0; i < dealTagsArray.length; i++) {
                tagTexts.push(dealTagsArray[i].tag_text);
            }
            var tagTextsString = '';
            if (tagTexts.length > 0) {
                tagTextsString = ', ' + tagTexts.join(', ');
            }
            if (currenDealType == 'SIM') {
                window.dataLayer.push({
                    'event': 'sim_upsell_modal',
                    'clicked_sim': '£' + $('#currenDealType').data('contractprice') + ' ' + $('#currenDealType').data('contractdata') + ' ' + $('#currenDealType').data('contractlength') + 'M' + tagTextsStringClicked,
                    'recommended_sim': '£' + upsellMonthlyCost + ' ' + upsellData + ' ' + upsellContrctLength + 'M' + tagTextsString,
                    'element_placement': 'basket'
                });
            }
            if (currenDealType == 'Handset') {
                window.dataLayer.push({
                    'event': 'handset_upsell_modal',
                    'clicked_handset': '£' + $('#currenDealType').data('contractprice') + ' ' + $('#currenDealType').data('contractdata') + ' ' + $('#currenDealType').data('contractlength') + 'M' + ' (£' + $('#currenDealType').data('upfrontcost') + ' upfront)' + tagTextsStringClicked,
                    'recommended_handset': '£' + upsellMonthlyCost + ' ' + upsellData + ' ' + upsellContrctLength + 'M' + ' (£' + upsellUpfrontCost + ' upfront)' + tagTextsString,
                    'element_placement': 'basket'
                });
            }
        } else {
            $('#basket-form').submit();
        }
    });
    $('body').on('click', '#basketupsellModalCloseBtn', function() {
        $('#basketupsellModal').modal('hide');
        $('#basket-form').submit();
    });
});
